const t=(t,n,o)=>JSON.stringify(t,((t,o)=>{const i="bigint"==typeof o?o.toString():o;return"function"==typeof n?n(t,i):i}),o);export{t as stringify};
